// Inlined from packages/shared/error-codes.js — packages/shared sits outside
// apps/web and is not reliably available in all build environments.
export const ERROR_CODES = Object.freeze({
  NOT_FOUND: 'NOT_FOUND',
  UNAUTHORIZED: 'UNAUTHORIZED',
  FORBIDDEN: 'FORBIDDEN',
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  RATE_LIMITED: 'RATE_LIMITED',
  CONFLICT: 'CONFLICT',
  SERVER_ERROR: 'SERVER_ERROR',
});

export const STATUS_BY_CODE = Object.freeze({
  NOT_FOUND: 404,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  VALIDATION_ERROR: 400,
  RATE_LIMITED: 429,
  CONFLICT: 409,
  SERVER_ERROR: 500,
});
